import { render, staticRenderFns } from "./ShowUpdate.vue?vue&type=template&id=2a3fb6ca&"
import script from "./ShowUpdate.vue?vue&type=script&lang=js&"
export * from "./ShowUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports